import { useCallback, useContext } from 'react';
import { AppContext } from '../AppContext';
import { convertToUserTime } from '../Utils';

export type FormatUserTime = (utcTime: string) => string;

export function useUserTime(): FormatUserTime {
  const { user } = useContext(AppContext);

  return useCallback(
    (utcTime: string) => convertToUserTime(utcTime, user.timezone),
    [user.timezone]
  );
}
